<mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      <mat-icon color="primary">menu</mat-icon> My Drive
    </button>
  </div>
  <div class="d">
    <button mat-flat-button (click)="showDocDetail()">
      <mat-icon>keyboard_arrow_left</mat-icon> Details
    </button>
  </div>
</mat-card>

<div class="coreholder" fxLayout="row">
  <!-- My Drive -->

  <mat-card class="myDrive" [ngClass]="{ open: showmyDrive }">
    <app-left-menu></app-left-menu>
  </mat-card>

  <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{ open: showmyDrive }"></div>

  <!-- My Drive -->

  <!-- Core page Structure -->
  <mat-card class="corepages">
    <!-- Filter -->
    <mat-card class="filter">
      <label>{{ Module }}</label>

      <div class="view_list">
        <button mat-icon-button [ngClass]="{ active: showList }" mat-icon-button (click)="showListopt()">
          <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button mat-icon-button [ngClass]="{ active: showGrid }" (click)="showGridopt()">
          <mat-icon>apps</mat-icon>
        </button>
      </div>

      <ng-container *ngIf="showFavDeletePanel">
        <div class="slAct">
          <button mat-icon-button (click)="AddFavorite()">
            <mat-icon>grade</mat-icon>
          </button>

          <button mat-icon-button (click)="DeleteSelectRecord()">
            <mat-icon>delete</mat-icon>
          </button>
          
          <!-- <button mat-icon-button (click)="DeleteSelecteOrAllFolders()">
            <mat-icon>delete</mat-icon>
          </button> -->
        </div>
      </ng-container>

      <div class="projectSearch">
      
        <button class="searchbtn" [disabled]="searchKey == ''"  mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
       
        <input placeholder="Search {{ Module }} & folder..." type="text"  maxlength="30" [(ngModel)]="searchKey" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
       
        <button class="filterbtn" mat-icon-button (click)="applyFilter()"
        matTooltipClass="tooltip" matTooltip="Filters">
       <mat-icon>filter_list</mat-icon>
      </button>
     

     </div>

      <!-- <mat-form-field appearance="">
        <mat-label>Search {{ Module }} & folder... </mat-label>
        <input matInput type="text" [(ngModel)]="searchKey" (keyup)="$event.keyCode == 13
              ? Search($event.target.value)
              : $event.target.value == ''
              ? Search($event.target.value)
              : null" />
        <button [disabled]="searchKey == ''" matSuffix mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
      </mat-form-field>

      <button class="filterbtn" mat-icon-button (click)="applyFilter()">
        <mat-icon>filter_list</mat-icon>
      </button> -->

      <!-- <div class="add">
        <button mat-flat-button color="primary" (click)="CreatePdfForm()">Create PDF Form</button>
      </div> -->
      <div class="add">
        <button mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon> Create</button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="CreatePdfForm(true)">PDF Form</button>
          <button mat-menu-item (click)="CreateAuditForm(true)">Tabular Form</button>
          <button mat-menu-item (click)="CreateHTMLForm(true)">Web Form</button>
          <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreatePdfForm(false)">Master PDF Form</button>
          <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateAuditForm(false)">Master Tabular Form</button>
          <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateHTMLForm(false)">Master Web Form</button>
        </mat-menu>
      </div>
    </mat-card>


    <div class="folders" *ngIf="RecentlyViewFolderList.length > 0">
      <div class="heading">
        <span>Quick Access</span>
      </div>
      <div class="allfolder">
        <mat-card class="folder" *ngFor="let f of RecentlyViewFolderList">
          <div class="iconUser">
            <div class="docType">
              <mat-icon *ngIf="f.type == 1">folder</mat-icon>
              <!-- <mat-icon *ngIf="f.type == 2">description</mat-icon> -->
              <!-- <img *ngIf="f.type == 2" src="../../../../assets/images/icons/formIcon.svg" alt="" width="30" > -->
              <app-doc-icons *ngIf="f.type == 2" [iconType]="'FORM'"></app-doc-icons>
            </div>
            <h4 (click)="getFormFolderDetails(f)">{{ f.name }}</h4>
            <ng-container>
              <div class="countshare">
                <div class="userlist">
                  <button mat-icon-button (click)="addContactOrRole(f, f.type == 1 ? true : false)" color="primary">
                    <mat-icon>share</mat-icon>
                  </button>
                  <div class="userCount" (click)="showSharedContactRoleList(f)" matTooltipClass="tooltip">
                    {{ f.itemCount }}
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </mat-card>
      </div>
    </div>
    <ng-container *ngIf="isShowForm">
      <div class="breadcumb">
        <span (click)="breadCrumbMainClick()">{{ Module }}</span>
        <span *ngFor="let m of menuHeader; let i = index">
          <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
          <a (click)="breadCrumb(menuHeader, i)">{{ m.label }} </a>
        </span>
        <span class="" *ngIf="ShowCreateButton">
          <button mat-icon-button class="createNew" color="primary" (click)="createFolders()">
            <mat-icon>create_new_folder</mat-icon>
          </button>
        </span>
      </div>

      <mat-card class="grid" *ngIf="!showList">
        <ul>
          <li *ngFor="let form of FormFolderList" class="gridItem">
            <div class="gridblock">
              <div class="opicon">
                <div class="opts">
                  <mat-checkbox color="primary" (change)="isAllSelectedRow($event, form)"
                    (change)="$event ? selection.toggle(form) : null" [checked]="selection.isSelected(form)">
                  </mat-checkbox>

                  <div class="grade">
                    <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                      <mat-icon class="fav" (click)="DeleteFavorite(form)">grade</mat-icon>
                    </ng-container>
                    <ng-template #showFavorite>
                      <mat-icon class="star" (click)="AddRowFavorite(form)">grade</mat-icon>
                    </ng-template>
                  </div>

                  <button class="ml-auto" (click)="addContactOrRole(form, form.type == 1 ? true : false)"
                    mat-icon-button>
                    <mat-icon>share</mat-icon>
                  </button>

                  <ng-container>
                    <div class="act" *ngIf="form.type == 1">
                      <button mat-icon-button [matMenuTriggerFor]="folder">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #folder="matMenu" xPosition="before">
                        <button mat-menu-item (click)="getform(form)">
                          <mat-icon>folder_open</mat-icon> Open
                        </button>

                        <button mat-menu-item (click)="AddSuccessDeclineUrl(form)">
                          <mat-icon>note_add</mat-icon> Add Url
                        </button>
                        
                        <button mat-menu-item (click)="linkCopied()" [cdkCopyToClipboard]="form.pdfTokenUrl">
                          <mat-icon>link</mat-icon> PDF Forms Url
                        </button>

                        <button mat-menu-item (click)="linkCopied()" [cdkCopyToClipboard]="form.webTokenUrl">
                          <mat-icon>link</mat-icon> Web Forms Url
                        </button>

                        <ng-container *ngIf="form.name != 'My Forms'">
                          <button mat-menu-item *ngIf="showLocalPanel" (click)="CreatePdfForm(true)">
                            <mat-icon>picture_as_pdf</mat-icon> Create PDF Form
                          </button>
                          <button mat-menu-item (click)="RenameFolders(form)">
                            <mat-icon>format_size</mat-icon> Rename
                          </button>
                          <button mat-menu-item (click)="MoveTo(form)">
                            <mat-icon>low_priority</mat-icon> Move to
                          </button>
                          <button mat-menu-item (click)="DeleteFolders(form)">
                            <mat-icon>delete_outline</mat-icon> Delete
                          </button>


                        </ng-container>
                        <button mat-menu-item (click)="addContactOrRole(form, form.type == 1 ? true : false)">
                          <mat-icon>share</mat-icon>Share
                        </button>
                      </mat-menu>
                    </div>
                  </ng-container>

                  <div class="act" *ngIf="form.type == 2">
                    <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #formTypeOpt="matMenu" xPosition="before">
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL
                      </button>
                      <button mat-menu-item (click)="openProject(form)">
                        <mat-icon>assignment</mat-icon> Create Project
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                        <mat-icon>supervised_user_circle</mat-icon> File Access
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" [routerLink]="'/esignature/report'">
                        <mat-icon>donut_large</mat-icon>Show Report
                      </button>

                      <button mat-menu-item (click)="RenameFolders(form)">
                        <mat-icon>format_size</mat-icon> Rename
                      </button>

                      <button mat-menu-item (click)="MoveTo(form)">
                        <mat-icon>low_priority</mat-icon> Move to
                      </button>

                      <button mat-menu-item (click)="openTemplate(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <button mat-menu-item (click)="DeleteTemplate(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button>

                      <button mat-menu-item (click)="getformDetails(form)">
                        <mat-icon>visibility</mat-icon> Details
                      </button>
                      
                      <button mat-menu-item (click)="addContactOrRole(form, form.type == 1 ? true : false)">
                        <mat-icon>share</mat-icon>Share
                      </button>
                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <div class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == false" (click)="getform(form)">
                  <mat-icon>folder</mat-icon>
                </div>

                <div class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == true" (click)="getform(form)">
                  <mat-icon>folder_shared</mat-icon>1
                </div>

                <div class="mat-cell formIcon" *ngIf="form.type == 2 && form.formType==1" (click)="openProject(form)">
                  <!-- <mat-icon>feed</mat-icon> -->
                  <!-- <img  src="../../../../assets/images/icons/formIcon.svg" alt="" width="30"/> -->
                  <app-doc-icons [iconType]="'FORM'"></app-doc-icons>
                </div>

                <div class="mat-cell formIcon" *ngIf="form.type == 2 && form.formType==2" (click)="openProject(form)">
                  <!-- <mat-icon>table_rows</mat-icon> -->
                  <!-- <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="30"/> -->
                  <app-doc-icons [iconType]="'TABULAR'"></app-doc-icons>
                </div>

                <div class="mat-cell formIcon" *ngIf="form.type == 2 && form.formType==3">
                  <!-- <mat-icon>table_rows</mat-icon> -->
                  <!-- <img src="../../../../assets/images/icons/form_html.svg" alt="" width="30"/> -->
                  <app-doc-icons [iconType]="'HTML'"></app-doc-icons>
                </div>

              </div>

              <div class="namedate">

                <ng-container class="mat-cell" *ngIf="form.type == 1 && form.formType!=3" (click)="getform(form)">
                  <p class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">
                    {{ form.name }}
                  </p>
                </ng-container>

                <ng-container class="mat-cell" *ngIf="form.type == 2 && form.formType!=3">
                  <p class="formName" matTooltipClass="tooltip" (click)="openProject(form)"
                    matTooltip="{{ form.name }}">
                    {{ form.name }}
                  </p>
                </ng-container>


                <ng-container class="mat-cell" *ngIf="form.type == 2 && form.formType==3">
                  <p class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">
                    {{ form.name }}
                  </p>
                </ng-container>

                <span>{{ form.createdOn | date: "MM/dd/yyyy" }}</span>
              </div>
            </div>
          </li>
        </ul>

        <ng-container *ngIf="!FormFolderList || FormFolderList?.length == 0">
          <p class="nocontent">No Items Found</p>
        </ng-container>
      </mat-card>

      <mat-card class="files" *ngIf="showList">
        <table class="mat-table">
          <thead>
            <tr class="mat-header-row">
              <th class="mat-header-cell wfolder">
                <span class="checkbo">
                  <mat-checkbox color="primary" [disabled]="!FormFolderList" (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()">
                  </mat-checkbox>
                </span>
              </th>
              <th class="mat-header-cell wstar"></th>
              <th class="mat-header-cell wfolder"></th>
              <th class="mat-header-cell">Name</th>
              <th class="mat-header-cell shareIcon">&nbsp;</th>
              <th class="mat-header-cell date">Created On</th>
              <th class="mat-header-cell date">Modified On</th>
              <th class="mat-header-cell action">Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let form of FormFolderList">
              <tr class="mat-row foldericon">
                <td class="mat-cell">
                  <span class="checkbo">
                    <mat-checkbox color="primary" (change)="isAllSelectedRow($event, form)"
                      (change)="$event ? selection.toggle(form) : null" [checked]="selection.isSelected(form)">
                    </mat-checkbox>
                  </span>
                </td>

                <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                  <td class="mat-cell">
                    <mat-icon class="fav" (click)="DeleteFavorite(form)">grade</mat-icon>
                  </td>
                </ng-container>

                <ng-template #showFavorite>
                  <td class="mat-cell">
                    <mat-icon class="star" (click)="AddRowFavorite(form)">grade</mat-icon>
                  </td>
                </ng-template>

                <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == false" (click)="getform(form)">
                  <mat-icon>folder</mat-icon>
                </td>
                <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == true" (click)="getform(form)">
                  <mat-icon>folder_shared</mat-icon>
                </td>

                <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1"
                  (click)="getformDetails(form)">
                  <!-- <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="30"/> -->
                  <app-doc-icons [iconType]="'FORM'"></app-doc-icons>
                </td>

                <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                  <!-- <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="30"/> -->
                  <app-doc-icons [iconType]="'TABULAR'"></app-doc-icons>
                </td>

                <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                  <!-- <img src="../../../../assets/images/icons/form_html.svg" alt="" width="30"/> -->
                  <app-doc-icons [iconType]="'HTML'"></app-doc-icons>
                </td>

                <td class="mat-cell" *ngIf="form.type == 1 && form.formType!=3" (click)="getform(form)">
                  <span class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">{{ form.name }}
                  </span>
                </td>
                <td class="mat-cell" *ngIf="form.type == 2 && form.formType!=3">
                  <span class="formName" matTooltipClass="tooltip" [matMenuTriggerFor]="formTypeOpt"
                    matTooltip="{{ form.name }}">{{ form.name }}

                    <mat-menu #formTypeOpt="matMenu" xPosition="before">
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL
                      </button>
                      <button mat-menu-item (click)="openProject(form)">
                        <mat-icon>assignment</mat-icon> Create Project
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                        <mat-icon>supervised_user_circle</mat-icon> File Access
                      </button>

                      <button mat-menu-item  (click)="openPDFFormData(form)">
                        <mat-icon>donut_large</mat-icon>Show Report
                      </button>

                      <button mat-menu-item (click)="RenameFolders(form)">
                        <mat-icon>format_size</mat-icon> Rename
                      </button>

                      <button mat-menu-item (click)="MoveTo(form)">
                        <mat-icon>low_priority</mat-icon> Move to
                      </button>

                      <button mat-menu-item (click)="openTemplate(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <button mat-menu-item (click)="DeleteTemplate(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button>

                      <button mat-menu-item (click)="getformDetails(form)">
                        <mat-icon>visibility</mat-icon> Details
                      </button>
                      <button mat-menu-item (click)="addContactOrRole(form, form.type == 1 ? true : false)">
                        <mat-icon>share</mat-icon>Share
                      </button>
                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>
                      <button  mat-menu-item (click)="selectIcon(form)">
                        <mat-icon>add</mat-icon>Dashboard Quick Link
                      </button>
                    </mat-menu>

                  </span>
                </td>

                <td class="mat-cell" *ngIf="form.type == 2 && form.formType==3">
                  <span class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}"
                    [matMenuTriggerFor]="formTypeOpt">{{ form.name }}

                    <mat-menu #formTypeOpt="matMenu" xPosition="before">
                      <button *ngIf="form.type == 2 && form.formType==3" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>

                      <button mat-menu-item (click)="openHTMLForm(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="openHtmlData(form)">
                        <mat-icon>visibility </mat-icon> View Report
                      </button>

                      <button mat-menu-item (click)="DeleteTemplate(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button>

                      <button mat-menu-item (click)="HTMLFormSign(form)">
                        <mat-icon>open_with </mat-icon> Open Form
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form, true)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>>

                    </mat-menu>
                  </span>
                </td>

                <td class="mat-cell">
                  <button class="shareFileFol" (click)="addContactOrRole(form, form.type == 1 ? true : false)"
                    mat-icon-button>
                    <mat-icon>share</mat-icon>
                  </button>
                </td>
                <!-- <td class="mat-cell" (click)="OpenFormOrProject(form)">
                  {{ form.createdOn | date: "MM/dd/yyyy" }}
                </td>
                <td class="mat-cell"  (click)="OpenFormOrProject(form)" *ngIf="form.updatedOn != null">
                  {{ form.updatedOn | date: "MM/dd/yyyy" }}
                </td>
                <td class="mat-cell" (click)="OpenFormOrProject(form)" *ngIf="form.updatedOn == null">
                  <p>-</p>
                </td> -->
                <td class="mat-cell">
                  {{ form.createdOn | date: "MM/dd/yyyy" }}
                </td>
                <td class="mat-cell" *ngIf="form.updatedOn != null">
                  {{ form.updatedOn | date: "MM/dd/yyyy" }}
                </td>
                <td class="mat-cell" *ngIf="form.updatedOn == null">
                  <p>-</p>
                </td>
                <td class="mat-cell">
                  <ng-container>
                    <div class="act" *ngIf="form.type == 1 && form.formType!=3">
                      <button mat-icon-button [matMenuTriggerFor]="folder">
                        <mat-icon>more_vertical</mat-icon>
                      </button>
                      <mat-menu #folder="matMenu" xPosition="before">
                        <button mat-menu-item (click)="getform(form)">
                          <mat-icon>folder_open</mat-icon> Open
                        </button>

                        <button mat-menu-item (click)="AddSuccessDeclineUrl(form)">
                          <mat-icon>note_add</mat-icon> Add Url
                        </button>

                        <button mat-menu-item (click)="linkCopied()" [cdkCopyToClipboard]="form.pdfTokenUrl">
                          <mat-icon>link</mat-icon> PDF Forms Url
                        </button>

                        <button mat-menu-item (click)="linkCopied()" [cdkCopyToClipboard]="form.webTokenUrl">
                          <mat-icon>link</mat-icon> Web Forms Url
                        </button>
                        <ng-container *ngIf="form.name != 'My Forms'">
                          <button mat-menu-item *ngIf="showLocalPanel" (click)="CreatePdfForm(true)">
                            <mat-icon>picture_as_pdf</mat-icon> Create PDF Form
                          </button>
                          <button mat-menu-item (click)="RenameFolders(form)">
                            <mat-icon>format_size</mat-icon> Rename
                          </button>
                          <button mat-menu-item (click)="MoveTo(form)">
                            <mat-icon>low_priority</mat-icon> Move to
                          </button>
                          <button mat-menu-item (click)="DeleteFolders(form)">
                            <mat-icon>delete_outline</mat-icon> Delete
                          </button>
                        </ng-container>
                        <button mat-menu-item (click)="addContactOrRole(form, form.type == 1 ? true : false)">
                          <mat-icon>share</mat-icon>Share
                        </button>
                      </mat-menu>
                    </div>
                  </ng-container>

                  <div class="act" *ngIf="form.type == 2 && form.formType!=3">
                    <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                      <mat-icon>more_vertical</mat-icon>
                    </button>
                    <mat-menu #formTypeOpt="matMenu" xPosition="before">
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL
                      </button>
                      <button mat-menu-item (click)="openProject(form)">
                        <mat-icon>assignment</mat-icon> Create Project
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                        <mat-icon>supervised_user_circle</mat-icon> File Access
                      </button>

                      <button mat-menu-item   (click)="openPDFFormData(form)">
                        <mat-icon>donut_large</mat-icon>Show Report
                      </button>

                      <button mat-menu-item (click)="RenameFolders(form)">
                        <mat-icon>format_size</mat-icon> Rename
                      </button>

                      <button mat-menu-item (click)="MoveTo(form)">
                        <mat-icon>low_priority</mat-icon> Move to
                      </button>

                      <button mat-menu-item (click)="openTemplate(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <button mat-menu-item (click)="DeleteTemplate(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button>

                      <button mat-menu-item (click)="getformDetails(form)">
                        <mat-icon>visibility</mat-icon> Details
                      </button>
                      <button mat-menu-item (click)="addContactOrRole(form, form.type == 1 ? true : false)">
                        <mat-icon>share</mat-icon>Share
                      </button>
                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>
                      <button  mat-menu-item (click)="selectIcon(form)">
                        <mat-icon>add</mat-icon>Dashboard Quick Link
                      </button>
                    </mat-menu>
                  </div>

                  <div class="act" *ngIf="form.type == 2 && form.formType==3">
                    <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                      <mat-icon>more_vertical</mat-icon>
                    </button>
                    <mat-menu #formTypeOpt="matMenu" xPosition="before">

                      <button *ngIf="form.type == 2 && form.formType==3" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>

                      <button mat-menu-item (click)="openHTMLForm(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="openHtmlData(form)">
                        <mat-icon>visibility </mat-icon> View Report
                      </button>

                      <button mat-menu-item (click)="DeleteTemplate(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button>
                      
                      <button mat-menu-item (click)="HTMLFormSign(form)">
                        <mat-icon>open_with </mat-icon> Open Form
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form, true)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>

                    </mat-menu>
                  </div>

                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!FormFolderList || FormFolderList?.length == 0">
              <tr>
                <td colspan="7">
                  <p class="nocontent">No Items Found</p>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </mat-card>

    </ng-container>

    <ng-container *ngIf="isSharedWithMe">
      <div class="breadcumb">
        <span (click)="breadCrumbMainSHaredWithMeClick()">Shared with me</span>
        <span *ngFor="let m of menuHeader; let i = index">
          <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
          <a (click)="breadCrumbShareWithMe(menuHeader, i)">{{ m.label }} </a>
        </span>
        <span class="" *ngIf="ShowCreateButton">
          <button mat-icon-button class="createNew" color="primary" (click)="createFoldersSharedWithMe()">
            <mat-icon>create_new_folder</mat-icon>
          </button>
        </span>
      </div>


      <mat-card class="grid" *ngIf="!showList">
        <ul *ngIf="SharedWithMeFormFolderList">
          <li *ngFor="let form of SharedWithMeFormFolderList" class="gridItem">
            <div class="gridblock">
              <div class="opicon">
                <div class="opts">

                  <span class="checkbo">
                    <mat-checkbox *ngIf="form.permissionType == 1" color="primary"
                      (change)="isAllSelectedRow($event, form)" (change)="$event ? selection.toggle(form) : null"
                      [checked]="selection.isSelected(form)">
                    </mat-checkbox>
                    <mat-checkbox *ngIf="form.permissionType == 0" disabled="true" color="primary"
                      [checked]="selection.isSelected(form)">
                    </mat-checkbox>
                  </span>

                  <div class="grade">
                    <mat-icon class="star" *ngIf="form.permissionType == 1"
                      (click)="AddRowFavorite(form, true)">grade</mat-icon>
                    <mat-icon class="star" *ngIf="form.permissionType == 0">grade</mat-icon>
                  </div>
                  <ng-container *ngIf="form.permissionType == 1">
                    <div class="act  ml-auto" *ngIf="form.type == 1">
                      <button mat-icon-button [matMenuTriggerFor]="folder">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #folder="matMenu" xPosition="before">
                        <button mat-menu-item (click)="getFormFolderWithFormTemplatesSharedWithMe(form)">
                          <mat-icon>folder_open</mat-icon> Open
                        </button>

                        
                        <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                          <mat-icon>format_size</mat-icon> Rename
                        </button>
                        <button mat-menu-item *ngIf="showLocalPanel">
                          <mat-icon>low_priority</mat-icon> Move to
                        </button>
                        <!-- <button mat-menu-item (click)="DeleteFoldersShareWithMe(form)">
                          <mat-icon>delete_outline</mat-icon> Delete
                        </button> -->
                      </mat-menu>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="form.permissionType == 0">
                    <div class="act  ml-auto" *ngIf="form.type == 1">
                      <button mat-icon-button [matMenuTriggerFor]="folder">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #folder="matMenu" xPosition="before">
                        <button mat-menu-item (click)="getFormFolderWithFormTemplatesSharedWithMe(form)">
                          <mat-icon>folder_open</mat-icon> Open
                        </button>
                      </mat-menu>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="form.permissionType == 1">
                    <div class="act  ml-auto" *ngIf="form.type == 2">
                      <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #formTypeOpt="matMenu" xPosition="before">
                        <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                          mat-menu-item (click)="linkCopied()">
                          <mat-icon>link</mat-icon> URL 
                        </button>
                        <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL
                        </button>
                        <button mat-menu-item (click)="openProject(form)">
                          <mat-icon>assignment</mat-icon> Create Project
                        </button>

                        <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                          <mat-icon>supervised_user_circle</mat-icon> File
                          Access
                        </button>

                        <button mat-menu-item *ngIf="form.type == 2 && form.formType==1" (click)="openPDFFormData(form)">
                          <mat-icon>donut_large</mat-icon>Show Report
                        </button>

                        <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                          <mat-icon>format_size</mat-icon> Rename
                        </button>

                        <button mat-menu-item *ngIf="showLocalPanel">
                          <mat-icon>low_priority</mat-icon> Move to
                        </button>

                        <button mat-menu-item (click)="openTemplate(form)">
                          <mat-icon>format_shapes </mat-icon> Edit
                        </button>

                        <button mat-menu-item (click)="makeaCopy(form, true)">
                          <mat-icon>content_copy</mat-icon> Make a copy
                        </button>

                        <!-- <button mat-menu-item (click)="DeleteTemplateShareWithMe(form)">
                          <mat-icon>delete_outline</mat-icon> Delete
                        </button> -->

                        <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                          <mat-icon>share</mat-icon>Share on Portal
                        </button>
                        <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                          <mat-icon>shuffle</mat-icon>UnShare on Portal
                        </button>

                      </mat-menu>

                    </div>
                  </ng-container>
                  <ng-container *ngIf="form.permissionType == 0">
                    <div class="act  ml-auto" *ngIf="form.type == 2">
                      <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      
                      <mat-menu #formTypeOpt="matMenu" xPosition="before">

                        <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                        </button>

                        <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL 
                       </button>
                      <button mat-menu-item (click)="openProject(form)">
                        <mat-icon>assignment</mat-icon> Create Project
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                        <mat-icon>supervised_user_circle</mat-icon> File
                        Access
                      </button>

                      <button mat-menu-item *ngIf="form.type == 2 && form.formType==1"  (click)="openPDFFormData(form)">
                        <mat-icon>donut_large</mat-icon>Show Report
                      </button>

                      <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                        <mat-icon>format_size</mat-icon> Rename
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel">
                        <mat-icon>low_priority</mat-icon> Move to
                      </button>

                      <button mat-menu-item (click)="openTemplate(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form, true)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <!-- <button mat-menu-item (click)="DeleteTemplateShareWithMe(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button> -->

                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>
                      </mat-menu>
                    </div>
                  </ng-container>

                </div>

                <div class="mat-cell docType" *ngIf="form.type == 1"
                  (click)="getFormFolderWithFormTemplatesSharedWithMe(form)">
                  <mat-icon>folder</mat-icon>
                </div>
                <div class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1"
                  (click)="openProject(form)">
                  <!-- <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="30" > -->
                  <app-doc-icons [iconType]="'FORM'"></app-doc-icons>
                </div>
                <div class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2"
                  (click)="openProject(form)">
                  <!-- <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="30" > -->
                  <app-doc-icons [iconType]="'TABULAR'"></app-doc-icons>
                </div>
                <div class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3"
                  (click)="openProject(form)">
                  <!-- <img src="../../../../assets/images/icons/form_html.svg" alt="" width="30"/> -->
                  <app-doc-icons [iconType]="'HTML'"></app-doc-icons>
                </div>
              </div>

              <div class="namedate">

                <ng-container *ngIf="form.type == 1">
                  <p class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">{{ form.name }}</p>
                </ng-container>

                <ng-container *ngIf="form.type == 2">
                  <p class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">{{ form.name }} </p>
                </ng-container>
                <span>
                  {{ form.createdOn | date: "MM/dd/yyyy" }}
                </span>

                <ng-container *ngIf="parentID==0">
                  <p class="formName" matTooltipClass="tooltip">By: {{ form.sharedbyFirstName }} {{
                    form.sharedbyLastName}}</p>
                </ng-container>

              </div>
            </div>
          </li>
        </ul>

        <ng-container *ngIf="!SharedWithMeFormFolderList">
          <p class="nocontent">No Items Found</p>
        </ng-container>
      </mat-card>

      <mat-card class="files" *ngIf="showList">
        <table class="mat-table">
          <thead>
            <tr class="mat-header-row">
              <th class="mat-header-cell wfolder">
                <span class="checkbo">
                  <mat-checkbox color="primary" [disabled]="!SharedWithMeFormFolderList"
                    (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()">
                  </mat-checkbox>
                </span>
              </th>
              <th class="mat-header-cell wstar"></th>
              <th class="mat-header-cell wfolder"></th>
              <th class="mat-header-cell">Name</th>
              <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
              <th class="mat-header-cell date">Created On</th>
              <th class="mat-header-cell date">Modified On</th>
              <th class="mat-header-cell action">Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="SharedWithMeFormFolderList">
              <tr class="mat-row foldericon" *ngFor="let form of SharedWithMeFormFolderList">
                <td class="mat-cell">
                  <span class="checkbo">
                    <mat-checkbox *ngIf="form.permissionType == 1" color="primary"
                      (change)="isAllSelectedRow($event, form)" (change)="$event ? selection.toggle(form) : null"
                      [checked]="selection.isSelected(form)">
                    </mat-checkbox>
                    <mat-checkbox *ngIf="form.permissionType == 0" disabled="true" color="primary"
                      [checked]="selection.isSelected(form)">
                    </mat-checkbox>
                  </span>
                </td>


                <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                  <td class="mat-cell">
                    <mat-icon class="fav" *ngIf="form.permissionType == 1"
                      (click)="DeleteFavorite(form, true)">grade</mat-icon>
                    <mat-icon class="fav" *ngIf="form.permissionType == 0">grade</mat-icon>
                  </td>
                </ng-container>

                <ng-template #showFavorite>
                  <td class="mat-cell">
                    <mat-icon class="star" *ngIf="form.permissionType == 1"
                      (click)="AddRowFavorite(form, true)">grade</mat-icon>
                    <mat-icon class="star" *ngIf="form.permissionType == 0">grade</mat-icon>
                  </td>

                </ng-template>

                <td class="mat-cell docType" *ngIf="form.type == 1"
                  (click)="getFormFolderWithFormTemplatesSharedWithMe(form)">
                  <mat-icon>folder</mat-icon>
                </td>
                <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1"
                  (click)="getformDetailsSharedWithMe(form)">
                  <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="30">
                </td>
                <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                  <img src="../../../../assets/images/icons/form_html.svg" alt="" width="30" />
                </td>
                <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                  <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="30">
                </td>

                <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)" *ngIf="form.type == 1">
                  <span class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">{{ form.name }}
                  </span>
                </td>
                <!-- <td (click)="openProject(form)" class="mat-cell" *ngIf="form.type == 2"> -->
                <td class="mat-cell" *ngIf="form.type == 2">
                  <span *ngIf="form.permissionType == 1 && form.type == 2" [matMenuTriggerFor]="formTypeOpt"
                    class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">{{ form.name }}
                    <mat-menu #formTypeOpt="matMenu" xPosition="before">
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL
                       </button>
                      <button mat-menu-item (click)="openProject(form)">
                        <mat-icon>assignment</mat-icon> Create Project 
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                        <mat-icon>supervised_user_circle</mat-icon> File
                        Access
                      </button>

                      <button mat-menu-item *ngIf="form.type == 2 && form.formType==1"  (click)="openPDFFormData(form)">
                        <mat-icon>donut_large</mat-icon>Show Report
                      </button>

                      <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                        <mat-icon>format_size</mat-icon> Rename
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel">
                        <mat-icon>low_priority</mat-icon> Move to
                      </button>

                      <button mat-menu-item (click)="openTemplate(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form, true)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <!-- <button mat-menu-item (click)="DeleteTemplateShareWithMe(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button> -->

                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>
                      <button  mat-menu-item (click)="selectIcon(form)">
                        <mat-icon>add</mat-icon>Dashboard Quick Link
                      </button>
                    </mat-menu>
                  </span>

                  <span *ngIf="form.permissionType == 0 && form.type == 2" [matMenuTriggerFor]="formTypeOpt"
                    class="formName" matTooltipClass="tooltip" matTooltip="{{ form.name }}">{{ form.name }}
                    <mat-menu #formTypeOpt="matMenu" xPosition="before">
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>
                      <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL
                       </button>
                      <button mat-menu-item (click)="openProject(form)">
                        <mat-icon>assignment</mat-icon> Create Project
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                        <mat-icon>supervised_user_circle</mat-icon> File
                        Access
                      </button>

                      <button mat-menu-item *ngIf="form.type == 2 && form.formType==1"  (click)="openPDFFormData(form)">
                        <mat-icon>donut_large</mat-icon>Show Report
                      </button>

                      <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                        <mat-icon>format_size</mat-icon> Rename
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel">
                        <mat-icon>low_priority</mat-icon> Move to
                      </button>

                      <button mat-menu-item (click)="openTemplate(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form, true)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <!-- <button mat-menu-item (click)="DeleteTemplateShareWithMe(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button> -->

                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>
                      <button  mat-menu-item (click)="selectIcon(form)">
                        <mat-icon>add</mat-icon>Dashboard Quick Link
                      </button>
                    </mat-menu>
                  </span>

                </td>

                <td class="mat-cell" *ngIf="parentID==0">
                  <span class="formName" matTooltipClass="tooltip">
                    {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                  </span>
                </td>

                <td class="mat-cell" (click)="OpenFormOrProjectSharedWithMe(form)">
                  {{ form.createdOn | date: "MM/dd/yyyy" }}
                </td>

                <td class="mat-cell" (click)="OpenFormOrProjectSharedWithMe(form)">
                  {{ form.updatedOn | date: "MM/dd/yyyy" }}
                </td>

                <td class="mat-cell">
                  <ng-container *ngIf="form.permissionType == 1">
                    <div class="act" *ngIf="form.type == 1">
                      <button mat-icon-button [matMenuTriggerFor]="folder">
                        <mat-icon>more_vertical</mat-icon>
                      </button>
                      <mat-menu #folder="matMenu" xPosition="before">
                        <button mat-menu-item (click)="getFormFolderWithFormTemplatesSharedWithMe(form)">
                          <mat-icon>folder_open</mat-icon> Open
                        </button>
                        
                        <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                          <mat-icon>format_size</mat-icon> Rename
                        </button>
                        <button mat-menu-item *ngIf="showLocalPanel">
                          <mat-icon>low_priority</mat-icon> Move to
                        </button>
                        <!-- <button mat-menu-item (click)="DeleteFoldersShareWithMe(form)">
                          <mat-icon>delete_outline</mat-icon> Delete
                        </button> -->
                        <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                          <mat-icon>share</mat-icon>Share on Portal
                        </button>
                        <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                          <mat-icon>shuffle</mat-icon>UnShare on Portal
                        </button>
                      </mat-menu>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="form.permissionType == 0">
                    <div class="act" *ngIf="form.type == 1">
                      <button mat-icon-button [matMenuTriggerFor]="folder">
                        <mat-icon>more_vertical</mat-icon>
                      </button>
                      <mat-menu #folder="matMenu" xPosition="before">
                        <button mat-menu-item (click)="getFormFolderWithFormTemplatesSharedWithMe(form)">
                          <mat-icon>folder_open</mat-icon> Open
                        </button>
                        
                        <!-- <button mat-menu-item (click)="getFormFolderWithFormTemplatesSharedWithMe(form)">
                          <mat-icon>visibility</mat-icon> Details
                        </button> -->
                      </mat-menu>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="form.permissionType == 1">
                    <div class="act" *ngIf="form.type == 2">
                      <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                        <mat-icon>more_vertical</mat-icon>
                      </button>
                      <mat-menu #formTypeOpt="matMenu" xPosition="before">

                        <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                          mat-menu-item (click)="linkCopied()">
                          <mat-icon>link</mat-icon> URL 
                        </button>

                        <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL
                        </button>
                        <button mat-menu-item (click)="openProject(form)">
                          <mat-icon>assignment</mat-icon> Create Project
                        </button>

                        <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                          <mat-icon>supervised_user_circle</mat-icon> File
                          Access
                        </button>

                        <button mat-menu-item  *ngIf="form.type == 2 && form.formType==1" (click)="openPDFFormData(form)">
                          <mat-icon>donut_large</mat-icon>Show Report
                        </button>

                        <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                          <mat-icon>format_size</mat-icon> Rename
                        </button>

                        <button mat-menu-item *ngIf="showLocalPanel">
                          <mat-icon>low_priority</mat-icon> Move to
                        </button>

                        <button mat-menu-item (click)="openTemplate(form)">
                          <mat-icon>format_shapes </mat-icon> Edit
                        </button>

                        <button mat-menu-item (click)="makeaCopy(form, true)">
                          <mat-icon>content_copy</mat-icon> Make a copy
                        </button>

                        <!-- <button mat-menu-item (click)="DeleteTemplateShareWithMe(form)">
                          <mat-icon>delete_outline</mat-icon> Delete
                        </button> -->

                        <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                          <mat-icon>share</mat-icon>Share on Portal
                        </button>
                        <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                          <mat-icon>shuffle</mat-icon>UnShare on Portal
                        </button>
                        <button  mat-menu-item (click)="selectIcon(form)">
                          <mat-icon>add</mat-icon>Dashboard Quick Link
                        </button>
                      </mat-menu>

                    </div>
                  </ng-container>
                  <ng-container *ngIf="form.permissionType == 0">
                    <div class="act" *ngIf="form.type == 2">
                      <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                        <mat-icon>more_vertical</mat-icon>
                      </button>

                      
                      <mat-menu #formTypeOpt="matMenu" xPosition="before">

                       <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.formTokenLink"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon> URL 
                      </button>

                        <button *ngIf="form.type == 2 && form.formType==1" [cdkCopyToClipboard]="form.signNowUrl"
                        mat-menu-item (click)="linkCopied()">
                        <mat-icon>link</mat-icon>Sign Now URL 
                       </button>
                      <button mat-menu-item (click)="openProject(form)">
                        <mat-icon>assignment</mat-icon> Create Project
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel" (click)="fileAccess(access)">
                        <mat-icon>supervised_user_circle</mat-icon> File
                        Access
                      </button>

                      <button mat-menu-item  *ngIf="form.type == 2 && form.formType==1" (click)="openPDFFormData(form)">
                        <mat-icon>donut_large</mat-icon>Show Report
                      </button>

                      <button mat-menu-item (click)="RenameFoldersSharedWithMe(form)">
                        <mat-icon>format_size</mat-icon> Rename
                      </button>

                      <button mat-menu-item *ngIf="showLocalPanel">
                        <mat-icon>low_priority</mat-icon> Move to
                      </button>

                      <button mat-menu-item (click)="openTemplate(form)">
                        <mat-icon>format_shapes </mat-icon> Edit
                      </button>

                      <button mat-menu-item (click)="makeaCopy(form, true)">
                        <mat-icon>content_copy</mat-icon> Make a copy
                      </button>

                      <!-- <button mat-menu-item (click)="DeleteTemplateShareWithMe(form)">
                        <mat-icon>delete_outline</mat-icon> Delete
                      </button> -->

                      <button *ngIf="form.sharedOnPortal==false" mat-menu-item (click)="shareOnPortal(form)">
                        <mat-icon>share</mat-icon>Share on Portal
                      </button>
                      <button *ngIf="form.sharedOnPortal==true" mat-menu-item (click)="unShareOnPortal(form)">
                        <mat-icon>shuffle</mat-icon>UnShare on Portal
                      </button>
                      <button  mat-menu-item (click)="selectIcon(form)">
                        <mat-icon>add</mat-icon>Dashboard Quick Link
                      </button>
                      </mat-menu>
                    </div>
                  </ng-container>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!SharedWithMeFormFolderList">
              <tr>
                <td colspan="7">
                  <p class="nocontent">No Items Found</p>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </mat-card>



    </ng-container>

  </mat-card>

  <mat-card class="documentDetail" [ngClass]="{ open: docDetail }">
    <app-doc-detail [typeId]="TypeId" [folderetails]="FormFolderDetailModel">
    </app-doc-detail>
  </mat-card>

  <div class="documentDetailOverlay" (click)="showDocDetail()" [ngClass]="{ open: docDetail }">
  </div>


</div>

<app-addnew *ngIf="showAddContact" (closeAdd)="getCloseAddNew($event)" [name]="searchName"
  [formFolderID]="formFolderIDSendToAPI" [formIDSendToAPI]="formIDSendToAPI" [mainModuleName]="mainModuleName"
  modulename="{{ modulenameContact }}" [ngClass]="{ open: showAddContact }">
</app-addnew>

<app-form-filter *ngIf="showFilter" (closeFilter)="getClose($event)" [ngClass]="{ open: showFilter }">
</app-form-filter>

<ng-template #addAssigne>
  <div class="head">
    <h2 matDialogTitle>Assign User</h2>
    <button mat-icon-button color="basic" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form class="assign">
      <app-contactlist></app-contactlist>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary">Assign</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #rename>
  <h2 matDialogTitle>Rename</h2>
  <mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>Rename</mat-label>
      <input matInput placeholder="Rename" value="Verification of Informed Consent for Psych Meds Form" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="">Close</button>
    <button mat-button color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #access>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>group_add</mat-icon></span>
    File Access
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <mat-card class="fileAccess">
      <table class="mat-table">
        <tr class="mat-header-row">
          <th class="mat-header-cell">Role</th>
          <th class="mat-header-cell w100">Read</th>
          <th class="mat-header-cell w100">Write</th>
          <th class="mat-header-cell w100">Delete</th>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Admissions</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Doctor</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Admin</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Employer</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
      </table>
    </mat-card>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #shareAdd>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>group_add</mat-icon></span>
    Share with Contact and Role
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <app-contactlist></app-contactlist>

    <ul class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="pic">
            <img src="../../../assets/images/avatars/{{ user.img }}" alt="" />
          </div>
          <div class="detail">
            <h4>{{ user.name }}</h4>
            <p>{{ user.email }}</p>
          </div>
        </div>
        <div class="option">
          <button mat-flat-button [matMenuTriggerFor]="menu" aria-label="Permission">
            <mat-icon>visibility</mat-icon>Viewer
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button disabled mat-menu-item>
              <mat-icon>visibility</mat-icon>
              <span>Viewer</span>
            </button>
            <button mat-menu-item>
              <mat-icon>text_fields</mat-icon>
              <span>Editor</span>
            </button>
            <button mat-menu-item>
              <mat-icon>delete</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </div>
      </li>
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>


<app-html-data (getCloseHtmlData)="getCloseHtmlData($event)" [ngClass]="{ open: htmlData }">
</app-html-data>
<app-PdfReport-data (getClosePDFReportData)="getClosePDFReportData($event)" [ngClass]="{ open: PDFReportData }">
</app-PdfReport-data>